
export default function Loading() {

    return (
        <div className={'loading-container'}>
            <h2>טוען
            ...</h2>
        </div>
    );
}